import React, { useState } from "react";
//import { connect } from "react-redux";
//import { hasErrors } from "../../../utils";
//import { Spinner } from "../../../view/Spinner";
import { CardTypes } from "./VulscanScheduleCardService";
import VulscanTypeField from "../VulscanTypeField";
import VulscanCommandField from "../VulscanCommandField";
import VulscanTargetField from "../VulscanTargetField";


function VulscanScheduleCard({ errors, handleClose, cardType = CardTypes.CREATE }) {

    const initialState = {
        details: '',
        command: '',
        target:'',
        selectedType: null,
    }

    //const valid = !hasErrors(errors);

    //const [loading, setLoading] = useState(true);
    const [state, setState] = useState(initialState);
    //const [scanTypesData, setScanTypesData] = useState([]);


    //const NmapScheduleCardService = new NmapScheduleCardService(cardType, handleClose);
 const onTypeChange = (value, details, command) => {
        setState({
          ...state,
          selectedType: value,
          details: details,
          command: command,
        });
      }

    const onTargetChange = (value) => {
        //let commandText = state.command;
        setState({
        ...state,
        target: value,
        //command: commandText + " " + state.target
    });
    };

    const onCommandChange = (value) => {
    // setState({
    //     ...state,
    //     command: value
    // });
    };
    
    // const fetchData = async () => {
    //     // try {
    //     //     const userRoleList = await authService.listRoles();
    //     //     setUserRoles(userRoleList);

    //     //     if (userId && cardType === CardTypes.EDIT) {
    //     //         const user = await getUserById(userId);
    //     //         if (user) {
    //     //             setUsername(user.username);
    //     //             setFirstName(user.firstName);
    //     //             setLastName(user.lastName);
    //     //             setEmail(user.email);
    //     //             setUserRoleId(user.userRole.pk);

    //     //             if (user.type === externalUser) {
    //     //                 setUserType(externalUser);
    //     //                 setPassword(externalUser);
    //     //                 setAdUser(true);
    //     //                 setPasswordVisible(false);
    //     //             } else {
    //     //                 setUserType(localUser);
    //     //                 setPassword('******');
    //     //                 setAdUser(false);
    //     //                 setPasswordVisible(true);
    //     //             }

    //     //             // if (user.logoUrl) {
    //     //             //     setImagePreview(getImage(user.logoUrl));
    //     //             // }
    //     //         }
    //     //     } else {
    //     //         validationService.validateNotEmpty(username, 'username');
    //     //         validationService.validateNotEmpty(password, 'password');
    //     //         validationService.validateNotEmpty(firstName, 'firstName');
    //     //         validationService.validateNotEmpty(lastName, 'lastName');
    //     //         validationService.validateNotEmpty(email, 'email');
    //     //         validationService.validateRoleSelected("", 'userRole');
    //     //     }

    //     //     setLoading(false);
    //     // } catch (error) {
    //     //     console.error('Error:', error);
    //     //     setLoading(false);
    //     // }
    // };

    // useEffect(() => {
    //     // fetchData();

    //     // return () => {
    //     //     validationService.cleanState();
    //     // };
    //     /* eslint-disable react-hooks/exhaustive-deps */
    // }, []);

 
    return (
        // <div>
        //     <div className="card">
        //         <div className="card-body-uc">
        //             {loading ? <Spinner />
        //                 :
                        <>
                        <div className="oct_container-content-center w-100">
                            <form action="" className="oct_form pt-5 w-100">
                                <div className="row mb-3 mb-lg-3">
                                    <div className="col-xs-12 col-sm-6 col-md-7 col-xl-8">
                                        <div className="row mb-3 mb-lg-3">
                                            <div className="col-xs-12 col-sm-6 col-md-7 col-xl-6">
                                                <VulscanTypeField value={state.selectedType}
                                                                  onChange={onTypeChange}/>
                                            </div> 
                                            <div className="col-xs-12 col-sm-6 col-md-7 col-xl-6">
                                                <VulscanTargetField value={state.target}
                                                                    onChange={onTargetChange}/>
                                            </div>
                                            <div className="col-xs-8 col-sm-8 col-md-8 col-xl-8">
                                            <VulscanCommandField value={state.command + " " + state.target}
                                                onChange={onCommandChange}/>
                                        </div>
                                            
                                            {/* <div className="col-xs-4 col-sm-4 col-md-4 col-xl-4">
                                                <ScheduleScanButton target={state.target}
                                                    command={state.command}
                                                    type={state.selectedType}
                                                />
                                            </div> */}
                                        </div> 
            
                                        
                                    </div>
            
                                    
                                </div>
            
                                             
                            </form>
                        </div>
                    </>
        //             }

        //         </div>
        //     </div>
        // </div>
    )
}

// function mapStateToProps(state) {
//     debug("VulscanTable mapStateToProps", state);
//     const vulscanPage = state.vulscanPage;
//     return {
//         scanList: vulscanPage.scanList || []
//     };
// }

//export default connect(mapStateToProps)(VulscanScheduleCard);

export default VulscanScheduleCard;
